export function getInitialLanguage(): string{
  let result = localStorage.getItem("culture"); 
  if(!result){
    result = navigator.language
  } else{
    result = result.replace(/"/g, '');
  }
  return result
}